import "./Form.css"
import React from 'react'

const Form = () => {
  return (
<div className="form" id="contact">
<h1 style={{
      paddingTop: "20px",
      textAlign: "center"
    }}>Contact Me</h1>
 <form >
    <label>Your Name</label>
    <input type="text" />

    <label>Email</label>
    <input type="email" />

    <label>Subject</label>
    <input type="text" />

    <label>Message</label>
   <textarea rows="6" placeholder="type your message here"></textarea>

<button className="btn">Submit</button>

 </form>
</div>
  )
}

export default Form